export default "__VITE_ASSET__BTG2Lg_I__"